import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardState } from './dashboard.reducer';
import {AppState} from "../../shared/state/app.state";

export const selectDashboardState = (state: AppState) => state.dashboards;

export const selectRecentActivity = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.recentActivity
);

export const selectRecentActivityStatus = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.recentActivityStatus
);

export const selectDashboardStatistics = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.dashboardStatistics
);

export const selectDashboardStatisticsStatus = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.dashboardStatisticsStatus)
;

export const selectError = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.error
);
